export default __webpack_public_path__ + "static/media/attendance_ic.39894fad.svg";